import {
  Share2, CalendarClock, PieChart, Video, Heart, Palette, Home, Star, Clapperboard,
  Instagram, Facebook, Linkedin, Youtube, Music2,
} from "lucide-react";

export const STATUS_BADGE = {
  VERIFIED: { label: "Verified", color: "#5F8213", bg: "rgba(147,192,32,.14)" },
  ESTIMATED: { label: "Estimated", color: "#2F6BFF", bg: "rgba(47,107,255,.10)" },
  MANUAL: { label: "Manual", color: "#B8892B", bg: "rgba(184,137,43,.14)" },
  UNAVAILABLE: { label: "Data unavailable", color: "#8A8C82", bg: "rgba(138,140,130,.14)" },
  "DEMO DATA": { label: "Demo data", color: "#7C5BD9", bg: "rgba(124,91,217,.12)" },
};

export const COMPONENT_ICON = {
  social_presence: Share2,
  posting_consistency: CalendarClock,
  content_mix: PieChart,
  video_usage: Video,
  engagement: Heart,
  brand_consistency: Palette,
  property_marketing: Home,
  review_amplification: Star,
  nichecom_utilisation: Clapperboard,
};

export const SOCIAL_META = {
  instagram: { label: "Instagram", icon: Instagram },
  facebook: { label: "Facebook", icon: Facebook },
  linkedin: { label: "LinkedIn", icon: Linkedin },
  tiktok: { label: "TikTok", icon: Music2 },
  youtube: { label: "YouTube", icon: Youtube },
};

export const MIX_META = {
  property: { label: "Property", color: "#93C020" },
  video: { label: "Video", color: "#2F6BFF" },
  team: { label: "Team", color: "#B8892B" },
  community: { label: "Community", color: "#7C5BD9" },
  reviews: { label: "Reviews", color: "#E0567A" },
  educational: { label: "Educational", color: "#18A999" },
  brand: { label: "Brand", color: "#9A9C90" },
};

export function scoreColor(s) {
  if (s >= 75) return { fg: "#5F8213", bg: "rgba(147,192,32,.14)" };
  if (s >= 55) return { fg: "#B8892B", bg: "rgba(184,137,43,.14)" };
  if (s >= 40) return { fg: "#C9793B", bg: "rgba(201,121,59,.14)" };
  return { fg: "#C0473F", bg: "rgba(192,71,63,.12)" };
}

export const ANALYSIS_PHASES = [
  "Social presence", "Posting consistency", "Content mix", "Video usage",
  "Engagement", "Brand consistency", "Property content", "Reviews & reputation",
  "NicheCom utilisation", "Competitor position", "Missed opportunities", "Growth potential",
];
